__turbopack_context__.v({
  "container": "MapSection-module-scss-module__vS-hXq__container",
  "contentContainer": "MapSection-module-scss-module__vS-hXq__contentContainer",
  "locationBadge": "MapSection-module-scss-module__vS-hXq__locationBadge",
  "mapImage": "MapSection-module-scss-module__vS-hXq__mapImage",
  "mapWrapper": "MapSection-module-scss-module__vS-hXq__mapWrapper",
  "root": "MapSection-module-scss-module__vS-hXq__root",
});
